/**
 *
 * @module subscriptionStatus
 *
 */

import Check from 'check-types';
import SubscriptionStatusSubType from './subscriptionStatusSubType';
import SubscriptionStatusType from './subscriptionStatusType';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class SubscriptionStatus
 * @desc Represents the status a subscription can have.
 *
 */
export default class SubscriptionStatus {

    /**
     *
     * @param {Object} statusObj
     * @param {SubscriptionStatusSubType} [statusObj.subType]
     * @param {SubscriptionStatusType} statusObj.type
     *
     */
    constructor(statusObj) {

        const errorMessage = {
            ctor: 'SubscriptionStatus({ subType, type } = statusObj)',
            get statusObj() {
                return `${this.ctor} statusObj should be a plain Object`;
            },
            get type() {
                return `${this.ctor} type should be a String with length`;
            }
        };

        nonEmptyObject(statusObj, errorMessage.statusObj, InvalidArgumentException);

        const { subType, type } = statusObj;

        nonEmptyString(type, errorMessage.type, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {SubscriptionStatusSubType}
         * @desc Gets the subtype of the status (optional).
         *
         */
        this.subType = SubscriptionStatusSubType[subType];

        /**
         *
         * @access public
         * @type {SubscriptionStatusType}
         * @desc Gets the type of the status.
         *
         */
        this.type = SubscriptionStatusType[type];

    }

}



// WEBPACK FOOTER //
// ./src/services/subscription/subscriptionStatus.js